module.exports = __webpack_public_path__ + "img/ditto-tier-logo.b58104a2.png";